import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import {
  DivHeaderPositioning,
  Header1Hero,
} from "components/RethinkingTheGrid";

export const RethinkingTheGrid = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query UtilitiesRethinkingTheGridHeroImageQuery {
          file(relativePath: { eq: "Suburban.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 60% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 57% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 62% 50%;
              }
            }
            + picture > div,
            div {
              background: black;
            }
          `}
          file={file}
        />
      )}
    />
    <DivHeaderPositioning>
      <Header1Hero>
        {"Rethinking "}
        <br
          css={`
            @media screen and (min-width: ${getSize("tablet720")}) {
              display: none;
            }
          `}
        />
        {"the Grid"}
      </Header1Hero>
    </DivHeaderPositioning>
  </Section>
);
